import type { InputHTMLAttributes } from 'react';

import { CONTROL } from './control';
import { cx } from './cx';
import { useInvalid } from './fieldProblem';

/**
 * A number with its unit beside it: 84px of input, then the unit in `ink-3`.
 *
 * The unit is text rather than a suffix inside the box, because "minutes" and "минути" are
 * different widths and a suffix would push the digits around between the two languages. Its
 * 64px gutter is what makes a column of these line up down a settings page, which is the
 * whole reason it is a primitive rather than an input and a span.
 */
export function Measured({
  unit,
  wide,
  className,
  id,
  onChange,
  'aria-describedby': describedBy,
  ...rest
}: {
  unit: string;
  /**
   * 170px and left-aligned, for the one row that holds a list rather than a number — the
   * dispatch radii. The unit keeps its gutter, so the row still lines up with the rest.
   */
  wide?: boolean;
  className?: string;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'className'>) {
  const invalid = useInvalid(id, describedBy, onChange);

  return (
    <span className={cx('flex items-center gap-2', className)}>
      <input
        {...rest}
        {...invalid}
        id={id}
        className={cx(CONTROL, wide ? 'w-[170px]' : 'w-[84px] text-right')}
      />
      <span className="text-[13px] text-ink-3 min-w-16">{unit}</span>
    </span>
  );
}
